import hashHelper from 'hash-parse';

const history = {
    get: function (key, defaultValue = false) {
        const hash = hashHelper.parse(window.location.hash);

        if (hash[key]) {
            return hash[key];
        }

        return defaultValue;
    },

    set: function (obj) {
        hashHelper.set(obj)
    },
};

export default history;